import React, { Component } from "react";
import classnames from "classnames";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";

//import "../../assets/css/customstyles.css";

import imgUrl from "../../assets/images/imageUrl.js";
import Calendartabs from "./Calendartabs.js";


class CalendarPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  render() {
    return (
      <div className="gk-page getknowledgeable_page">
        <div className="gridcontainer">
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={12} className="caldivcontent zero">
              <Calendartabs></Calendartabs>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

export default CalendarPage;
